import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { useCallback } from "react";

dayjs.extend(utc);
dayjs.extend(timezone);

export function useFormatDateTime() {
  return useCallback(
    (
      dateTime: string | number | undefined | null,
      format: string,
      fallback: string = "--",
      targetTimezone?: string,
    ) => {
      if (!dateTime) return fallback;

      let date: dayjs.Dayjs;

      if (targetTimezone) {
        // 直接在目标时区创建dayjs对象
        date = dayjs.tz(dateTime, targetTimezone);
      } else {
        // 使用浏览器本地时区
        date = dayjs(dateTime);
      }

      if (!date.isValid()) return fallback;
      return date.format(format);
    },
    [],
  );
}
